import { motion } from "framer-motion";
import { Building2, TrendingUp, ArrowLeftRight } from "lucide-react";

const movements = [
  {
    icon: Building2,
    title: "Construir",
    description:
      "Cuando existe valor empresarial, pero todavía no fue convertido en una posición clara, diferenciada y reconocible.",
  },
  {
    icon: TrendingUp,
    title: "Elevar",
    description:
      "Cuando la empresa evolucionó, pero la percepción que construye quedó por debajo de su verdadero nivel.",
  },
  {
    icon: ArrowLeftRight,
    title: "Transferir",
    description:
      "Extender Capital de Marca® hacia una empresa, nueva generación, unidad, franquicia, producto u otro activo.",
  },
];

const ConstruirElevarTransferir = () => {
  return (
    <section
      id="metodo"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ backgroundColor: "#0a0f1a" }}
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-3xl" />

      <div className="container px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-16"
        >
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
            CONSTRUIR. ELEVAR. TRANSFERIR.
          </h2>
          <p className="text-lg text-neutral-400">
            Tres movimientos. Una misma dirección: hacer que el valor se convierta en Capital de Marca®.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {movements.map((m, i) => (
            <motion.div
              key={m.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="bg-gradient-to-b from-[#0a1628] to-[#0d1e36] rounded-2xl p-8 h-full border border-blue-900/40 hover:border-blue-500/50 transition-all duration-500"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center mb-6">
                <m.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-display text-2xl font-bold text-white mb-4">{m.title}</h3>
              <p className="text-neutral-400 leading-relaxed">{m.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConstruirElevarTransferir;
